export const appendProtocol = (url: string): string => {
    const hasProtocol = url && (url.startsWith('http://') || url.startsWith('https://'));

    return hasProtocol ? url : `http://${url}`;
};
